import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Pacientes from '@/views/Pacientes'
import Ficha from '@/views/Ficha'
import Agenda from '@/views/Agenda'
import Listareforco from '@/views/Listareforco'
import Listafinanceiro from '@/views/Listafinanceiro'
import Painel from '@/views/Painel'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      title: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/pacientes',
      name: 'Pacientes',
      component: Pacientes
    },
    {
      path: '/pacientes/ficha/:id',
      name: 'Ficha',
      component: Ficha
    },
    {
      path: '/agenda',
      name: 'Agenda',
      component: Agenda
    },
    {
      path: '/atendimentos/listareforco',
      name: 'Listareforco',
      component: Listareforco
    },
    {
      path: '/listafinanceiro',
      name: 'Listafinanceiro',
      component: Listafinanceiro
    },
    {
      path: '/painel',
      name: 'Painel',
      component: Painel
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name !== 'Login') {
    document.title = to.name

    if (localStorage.usuarioMC === 'undefined' || localStorage.usuarioMC === undefined || localStorage.usuarioMC === '') {
      next({ path: '/login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js